// react core
import { useContext, useState, useEffect } from "react";

// material design
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";

// fonts and icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMessage as iconUserChat } from "@fortawesome/pro-duotone-svg-icons";
// import { faCommentAltSmile as iconUserChat } from "@fortawesome/pro-duotone-svg-icons";
// import { faTimes as iconClose } from "@fortawesome/pro-thin-svg-icons";

// entzy config models and components
import configEntzy from "components/config/ConfigEntzy";
import { MainContext } from "components/main/MainContext";
import { ActionLoader } from "components/utils/common/CommonLoaders";
import {
  ModuleHeaderTag,
  ModuleSubHeaderTag,
} from "components/utils/common/CommonTags";
import { SETTINGS_CONSTANTS } from "models/Settings";

function MemberContacts(props) {
  // const user = props.user;
  const setMemberName = props.setMemberName;

  const mainContext = useContext(MainContext);
  const [loading, setLoading] = useState(false);

  // generate user list from message notifications
  useEffect(() => {
    const generateMemberList = async () => {
      setLoading(true);
      const expired = await mainContext.prepareEnrichContactList({
        getExpired: true,
      });
      if (expired.any) {
        const response = await mainContext.prepareEnrichContactList();
        if (response.alert) {
          mainContext.updateAlert(response);
        } else {
          mainContext.enrichContactList(response);
        }
      }
      setLoading(false);
    };
    if (!mainContext.state.alert?.show) {
      generateMemberList();
    }
  }, [mainContext]);

  const MemberButton = (props) => {
    const member = props.member;
    const containerClass = props.recent
      ? "box-default bg-black-t90 shadow-orange-glow action-pointover"
      : props.contact
      ? "box-default bg-black-t90 shadow-purple-glow action-pointover"
      : "box-default bg-black-t90 action-pointover";

    const unreadMessageCount =
      mainContext.state.notifications.data.messages.filter(
        (item) =>
          item.MessageUrl.includes(`@${member.User.name}`) && !item.MessageRead,
      ).length;

    return (
      <Box
        className="box-inline"
        sx={{
          width: "50%",
          p: configEntzy.APP_SPACING_MD,
        }}
      >
        <Box
          className={containerClass}
          sx={{
            p: configEntzy.APP_SPACING_MD,
            borderRadius: configEntzy.BORDER_SIZE_XL,
            opacity: props.blocked ? 0.2 : 1,
          }}
          onClick={() => setMemberName(member.User.name)}
        >
          <Box className="box-default">
            {unreadMessageCount > 0 && (
              <Box
                className="box-default relative zero-height"
                sx={{ zIndex: 1 }}
              >
                <Box
                  className="box-inline"
                  sx={{
                    width: configEntzy.AVATAR_CONTAINER_XS,
                    height: configEntzy.AVATAR_CONTAINER_XS,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                  }}
                >
                  <span className="fa-layers fa-fw fa-2x">
                    <FontAwesomeIcon
                      icon={iconUserChat}
                      transform="flip-h grow-4"
                      color="red"
                      className="fa-beat"
                      style={{
                        "--fa-animation-duration": "1.5s",
                        "--fa-beat-scale": 1.1,
                      }}
                    />
                    <span className="fa-layers-text">
                      <Typography variant="body2">
                        {unreadMessageCount}
                      </Typography>
                    </span>
                  </span>
                </Box>
              </Box>
            )}
            <Box className="box-inline">
              <Avatar
                variant="rounded"
                className="bg-black-t50 rounded"
                src={
                  member.User.avatar &&
                  member.User.avatar.hydrated &&
                  member.User.avatar.images
                    ? member.User.avatar.images.sm.data
                    : null
                }
                alt="Avatar"
                sx={{
                  width: configEntzy.AVATAR_SIZE_MD,
                  height: configEntzy.AVATAR_SIZE_MD,
                  backgroundColor: "transparent",
                  borderRadius: configEntzy.BORDER_SIZE_XL,
                  border: "1px solid #444",
                }}
              >
                <FontAwesomeIcon
                  icon={SETTINGS_CONSTANTS.iconImageFallback}
                  size="2x"
                  color="white"
                />
              </Avatar>
            </Box>
          </Box>
          <Box
            className="box-default"
            sx={{
              pt: configEntzy.APP_SPACING_SM,
            }}
          >
            <Typography variant="subtitle2" color="white">
              @{member.User.name}
            </Typography>
          </Box>
        </Box>
      </Box>
    );
  };

  return (
    <Box className="box-default">
      {loading ? (
        <Box
          className="box-default"
          sx={{
            pt: configEntzy.APP_SPACING_LG,
          }}
        >
          <ActionLoader size="small" />
        </Box>
      ) : (
        <Box className="box-default">
          <Box
            className="box-default"
            sx={{ mt: configEntzy.APP_SPACING_MD3X }}
          >
            <ModuleHeaderTag text="Your Member Contacts" />
          </Box>
          <Box className="box-default">
            <ModuleSubHeaderTag text="Recent" />
            <Box className="box-default">
              {mainContext.state.contactList.data.items
                .filter(
                  (member) =>
                    member.ContactUserId &&
                    member.enriched &&
                    member.enriched.recent &&
                    !member.ChatSettings.blocked,
                )
                .map((member) => {
                  return (
                    <MemberButton
                      key={member.key}
                      member={member}
                      recent={true}
                    />
                  );
                })}
            </Box>
            <Box
              className="box-default"
              hidden={
                mainContext.state.contactList.data.items.filter(
                  (member) =>
                    member.ContactUserId &&
                    member.enriched &&
                    member.enriched.recent &&
                    !member.ChatSettings.blocked,
                ).length > 0
                  ? true
                  : false
              }
            >
              <Typography variant="subtitle2" color="textSecondary">
                No recent interactions
              </Typography>
            </Box>
          </Box>
          <Box
            className="box-default"
            sx={{
              pt: configEntzy.APP_SPACING_LG,
            }}
          >
            <ModuleSubHeaderTag text="Contacts" />
            <Box className="box-default">
              {mainContext.state.contactList.data.items
                .filter(
                  (member) => member.contact && !member.ChatSettings.blocked,
                )
                .map((member) => {
                  return (
                    <MemberButton
                      key={member.key}
                      member={member}
                      contact={true}
                    />
                  );
                })}
            </Box>
            <Box
              className="box-default"
              hidden={
                mainContext.state.contactList.data.items.filter(
                  (member) => member.contact && !member.ChatSettings.blocked,
                ).length > 0
                  ? true
                  : false
              }
            >
              <Typography variant="subtitle2" color="textSecondary">
                No contacts available
              </Typography>
            </Box>
          </Box>
          <Box
            className="box-default"
            sx={{
              pt: configEntzy.APP_SPACING_HL2X,
              pb: configEntzy.APP_SPACING_LG,
            }}
          >
            <ModuleSubHeaderTag text="Blocked" />
            <Box className="box-default">
              {mainContext.state.contactList.data.items
                .filter((member) => member.ChatSettings.blocked)
                .map((member) => {
                  return (
                    <MemberButton
                      key={member.key}
                      member={member}
                      blocked={true}
                    />
                  );
                })}
            </Box>
            <Box
              className="box-default"
              hidden={
                mainContext.state.contactList.data.items.filter(
                  (member) => member.ChatSettings.blocked,
                ).length > 0
                  ? true
                  : false
              }
            >
              <Typography variant="subtitle2" color="textSecondary">
                No blocked members
              </Typography>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default MemberContacts;
